import { useTranslation } from 'react-i18next';
import { Routes, Route } from 'react-router';
import { useTitle } from 'react-use';

import ConversationsRouter from '@/components/pages/Conversations/ConversationsRouter';
import DeskIdProvider from '@/components/templates/DeskIdProvider';
import Layout from '@/components/templates/Layout';
import PermissionsWrapper from '@/components/templates/PermissionsWrapper';

import Chats from './Chats';

const ChatsRouter: React.FC = () => {
  const { t } = useTranslation();
  useTitle(t('pages.chat_simple'));
  return (
    <Layout>
      <PermissionsWrapper module="conversations">
        <Routes>
          <Route path="/" element={<Chats />} />
          <Route path="/:deskId/*" element={<DeskIdProvider />}>
            <Route path="*" element={<ConversationsRouter />} />
          </Route>
        </Routes>
      </PermissionsWrapper>
    </Layout>
  );
};

export default ChatsRouter;
